/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, Inject, Input} from '@angular/core';
import { UI_STATE } from '../../services/ui-state';

@Component({
    standalone: false,
    selector: 'help-text-trigger',
    templateUrl: './help-text-trigger.component.html',
    styleUrls: ['./help-text-trigger.component.css']
})
export class HelpTextTriggerComponent implements OnInit {
    @Input('for') public for!: string;

    constructor( @Inject(UI_STATE) private ui: any) {
    }

    ngOnInit() {
    }

    onClick() {
        this.ui[this.for] = true;
    }
}
